export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7308.53927a4d.jpg";